export default {"src":"/_next/static/media/verifier.88868e2d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};